import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-28308eea")

_pushScopeId("data-v-28308eea")
const _hoisted_1 = { class: "flex align-center" }
const _hoisted_2 = { class: "comment" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_page_header = _resolveComponent("el-page-header")
  const _component_el_divider = _resolveComponent("el-divider")
  const _component_el_empty = _resolveComponent("el-empty")
  const _component_el_avatar = _resolveComponent("el-avatar")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_timeline_item = _resolveComponent("el-timeline-item")
  const _component_el_timeline = _resolveComponent("el-timeline")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_el_page_header, {
      class: "margin-bottom-10",
      onBack: _ctx.goBack,
      content: "历史版本"
    }, null, 8, ["onBack"]),
    _createVNode(_component_el_divider),
    (_ctx.versions.length === 0)
      ? (_openBlock(), _createBlock(_component_el_empty, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_component_el_timeline, null, {
      default: _withId(() => [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.versions, (version, index) => {
          return (_openBlock(), _createBlock(_component_el_timeline_item, {
            icon: index === 0 ? 'el-icon-s-opportunity' : '',
            color: index === 0 ? '#0bbd87' : '',
            large: index === 0 ? 'large' : 'normal',
            key: version.version,
            timestamp: _ctx.format(version.createTime)
          }, {
            default: _withId(() => [
              _createVNode(_component_el_card, null, {
                default: _withId(() => [
                  _createVNode("div", _hoisted_1, [
                    _createVNode(_component_el_avatar, {
                      size: "small",
                      icon: "el-icon-user-solid",
                      src: version.author.avatar
                    }, null, 8, ["src"]),
                    _createVNode("h4", null, [
                      _createTextVNode(_toDisplayString(`${version.author.name || version.author.username}: `), 1),
                      _createVNode("span", _hoisted_2, _toDisplayString(version.comment), 1)
                    ])
                  ]),
                  _createVNode("audio", {
                    controls: "",
                    src: version.audio
                  }, null, 8, ["src"]),
                  _createVNode("pre", null, _toDisplayString(version.words), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1032, ["icon", "color", "large", "timestamp"]))
        }), 128))
      ]),
      _: 1
    })
  ], 64))
})